export const ROUTER_CONSTANT = Object.freeze({
    // Authentication
    INDEX: '/',
    LOGIN: '/login',
    LOGIN_SECOND: '/login2',
    GROCHAT_LOGIN: '/grochat-login',
    GROCHAT_MIGRATION: '/grochat-migration',
    GROCHAT_CANCEL: '/grochat-cancel',
    CREATE_NEW_ACCOUNT: '/create-new-account',
    RESET_PASSWORD: '/reset-password',
    NEW_PASSWORD: '/new-password',
    VERIFY_USER: '/user/activation',

    // Dashboard
    DASHBOARD: '/dashboard',
    RATING: '/dashboard/rating',
    DASHBOARD_PRINCIPAL: '/dashboard/principal',
    DASHBOARD_MANAGER: '/dashboard/manager',
    DASHBOARD_LEAD: '/dashboard/lead',
    DASHBOARD_OFFICER: '/dashboard/officer',
    MEMBER_TICKET: '/dashboard/member-ticket',

    // Notification
    NOTIFICATION: '/notification',

    // Ticket
    TICKET_LIST: '/ticket-list',
    TICKET_LIST_ALL: '/ticket-list/all',
    TICKET_DETAIL_ALL: '/ticket-list/all/detail/:id',
    TICKET_LIST_NEW: '/ticket-list/new',
    TICKET_DETAIL_NEW: '/ticket-list/new/detail/:id',
    TICKET_LIST_MEMBER: '/ticket-list/member',
    TICKET_DETAIL_MEMBER: '/ticket-list/member/detail/:id',
    TICKET_LIST_SOLUTION: '/ticket-list/solution',
    TICKET_DETAIL_SOLUTION: '/ticket-list/solution/detail/:id',
    TICKET_LIST_CREATE: '/ticket-list/create',

    // Contact
    CONTACT: '/contact',

    // History
    HISTORY: '/history',
    HISTORY_EMAIL: '/history/email',
    HISTORY_CHAT: '/history/chat',
    HISTORY_PHONE: '/history/phone',

    // Settings
    SETTINGS: '/settings',
    SETTINGS_CS_AGENT: '/settings/cs-agent',
    SETTINGS_PARAMETER: '/settings/parameter',
    SETTINGS_MONITORING: '/settings/monitoring',
    SETTINGS_LOGIN_HISTORY: '/settings/login-history',
    SETTINGS_QUEUE: '/settings/queue',
    SETTINGS_QUEUE_ASSIGNED: '/settings/queue/assigned',
    SETTINGS_QUEUE_ESCALATED: '/settings/queue/escalated',
    SETTINGS_SESSION: '/settings/session',
    SETTINGS_KMS: '/settings/kms',
    SETTINGS_KMS_CATEGORY: '/settings/kms/category',
    SETTINGS_KMS_CATEGORY_ADD: '/settings/kms/category/add',
    SETTINGS_KMS_CATEGORY_DETAIL: '/settings/kms/category/detail/:id',
    SETTINGS_KMS_LIST: '/settings/kms/list',
    SETTINGS_KMS_LIST_ADD: '/settings/kms/list/add',
    SETTINGS_KMS_LIST_DETAIL: '/settings/kms/list/detail',
    SETTINGS_KMS_LIST_EDIT: '/settings/kms/list/edit',
    SETTINGS_NEWS_FEED: '/settings/news-feed',
    SETTINGS_NEWS_FEED_ADD: '/settings/news-feed/add',
    SETTINGS_NEWS_FEED_DETAIL: '/settings/news-feed/detail/:id',
    SETTINGS_NEWS_FEED_EDIT: '/settings/news-feed/edit/:id',
    SETTINGS_ISSUE_CATEGORY: '/settings/issue-category',
    SETTINGS_ISSUE_CATEGORY_PRODUCT: '/settings/issue-category/product',
    SETTINGS_ISSUE_CATEGORY_MODULE: '/settings/issue-category/module',
    SETTINGS_ISSUE_CATEGORY_COMPLAINT: '/settings/issue-category/complaint',
    SETTINGS_COMMISSION_SCHEME: '/settings/commission-scheme',
    SETTINGS_CHATBOT_FLOW: '/settings/flow-chatbot',
    SETTINGS_CALL_HISTORY: '/settings/call-history',

    // Master Data
    MASTER_DATA: '/master-data',
    MASTER_DATA_ROLE: '/master-data/role',
    MASTER_DATA_ROLE_ADD: '/master-data/role/add',
    MASTER_DATA_ROLE_DETAIL: '/master-data/role/detail/:id',
    MASTER_DATA_ROLE_EDIT: '/master-data/role/edit/:id',
    MASTER_DATA_DATA_GROUP: '/master-data/data-group',
    MASTER_DATA_DATA_GROUP_ADD: '/master-data/data-group/add',
    MASTER_DATA_DATA_GROUP_DETAIL: '/master-data/data-group/detail/:id',
    MASTER_DATA_DATA_GROUP_EDIT: '/master-data/data-group/edit/:id',
    MASTER_DATA_DATA_CUSTOMER: '/master-data/data-customer',
    MASTER_DATA_SHIFT: '/master-data/shift',
    MASTER_DATA_SHIFT_ADD: '/master-data/shift/add',
    MASTER_DATA_SHIFT_DETAIL: '/master-data/shift/detail/:id',
    MASTER_DATA_SHIFT_EDIT: '/master-data/shift/edit/:id',
    MASTER_DATA_REMARK: '/master-data/remark',
    MASTER_DATA_REMARK_ROOT_CAUSE: '/master-data/remark/root-cause',
    MASTER_DATA_REMARK_PRIORITY: '/master-data/remark/priority',
    MASTER_DATA_REMARK_DOCUMENT_HEADER: '/master-data/remark/document-header',
    MASTER_DATA_REMARK_KMS_FEEDBACK: '/master-data/remark/kms-feedback',
    MASTER_DATA_REMARK_TICKET_FEEDBACK: '/master-data/remark/ticket-feedback',
    MASTER_DATA_REMARK_CHANNEL_NOTE: '/master-data/remark/channel-note',
    MASTER_DATA_REMARK_AUTOMATIC_MESSAGE: '/master-data/remark/automatic-message',
    MASTER_DATA_REMARK_ESCALATION: '/master-data/remark/escalation',
    MASTER_DATA_REMARK_CLOSED_TICKET: '/master-data/remark/closed-ticket',
    MASTER_DATA_USER: '/master-data/user',
    MASTER_DATA_USER_ADD: '/master-data/user/add',
    MASTER_DATA_USER_DETAIL: '/master-data/user/detail/:id',
    MASTER_DATA_USER_EDIT: '/master-data/user/edit/:id',
    MASTER_DATA_IMPORT: '/master-data/import',

    // Setup
    SETUP: '/setup',
    SETUP_PROFILE_SETTINGS: '/setup/profile-settings',

    // Report
    REPORT: '/report',
    REPORT_EXPORT_TICKET: '/report/export-ticket',
    REPORT_PRINCIPAL_TICKET: '/report/principal-report',

    // Errors
    FORBIDDEN: '/forbidden',
    SERVER_ERROR: '/500',
    ASSET_LINKS: '/.well-known/assetlinks.json',
});
